<template>
  <div class="content">
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.name"
          :label="$t('forms.labels.name')"
          :rules="{ required: true }"
          hideDetails
          outlined
          data-cy="flowMeterForm-name"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.make"
          :items="makes"
          :label="$t('forms.labels.make')"
          :rules="{ required: true }"
          hideDetails
          outlined
          data-cy="flowMeterForm-make"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.model"
          :label="$t('forms.labels.model')"
          :rules="{ required: true }"

          hideDetails
          outlined
          required
          data-cy="flowMeterForm-model"
          @input="updateData"
        />
      </v-col>
    </v-row>


    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.macAddress"
          :label="$t('devices.macAddress')"
          :rules="{ required: true, min: 1, max: 17, regex:/^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/ }"

          hideDetails
          outlined
          data-cy="flowMeterForm-model"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.connectionType"
          itemValue="key"
          required
          :label="$t('devices.connectionType')"
          :items="devicesList"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { CONNECTION_TYPES, AQ_GATEWAY } from '@/aquassist-shared/constants/types/deviceConnection';
import { mapGetters } from 'vuex';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import deviceHubMake from '@/constants/deviceHubMake';


export default {
    name: 'FlowMeterHubForm',
    components: {
        VSelect,
        VTextField,
    },
    props: {
        flowMeterHub: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {
                name: '',
                make: 'Aquassist',
                model: '',
                macAddress: '',
                connectionType: AQ_GATEWAY,
                indirectChannels: [null, null, null, null],
                directChannels: [null, null, null],
            },
            makes: deviceHubMake,
        };
    },

    computed: {
        ...mapGetters([
            'teamID',
            'site',
        ]),
        devicesList() {
            return CONNECTION_TYPES.map(item => ({
                key: item,
                name: this.$t(`devices.flowMetersHubs.connectionType.${item}`),
            }));
        },
    },

    async created() {
        if (this.flowMeterHub) {
            const meterHub = await this.$rq.getFlowMetersHub(this.site.id, this.flowMeterHub.id);
            // eslint-disable-next-line prefer-destructuring
            this.data = meterHub.data[0];
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};

</script>

<style lang="scss" scoped>
    .content {
        min-width: 300px
    }

</style>
